import React from 'react';
import { CardVariant, Chip, Count, Data, Delta, Period, Title, Wrapper } from './styled';
import { useLocale } from 'locale';

interface RealEstateCardProps {
  title: string;
  count: number;
  delta: number;
  isSmall?: boolean;
  variant?: CardVariant;
}

export const RealEstateCard: React.FC<RealEstateCardProps> = (props) => {
  const { title, count, delta, isSmall, variant } = props;
  const { t, formatNumber } = useLocale();

  return (
    <Wrapper isSmall={isSmall} variant={variant}>
      <Title variant={variant}>{title}</Title>
      <Data isSmall={isSmall} variant={variant}>
        <Count isSmall={isSmall} variant={variant}>{formatNumber(count)}</Count>
        {Number.isFinite(delta) ? (
          <Delta isSmall={isSmall} variant={variant}>
            <Period isSmall={isSmall} variant={variant}>{t('investors.market.result.period')}</Period>
            <Chip isGreen={delta > 0} isSmall={isSmall} variant={variant}>{delta > 0 ? '+' : ''}{delta}%</Chip>
          </Delta>
        ) : null}
      </Data>
    </Wrapper>
  );
};
